/** Dropzone accept map for Transaction Documents (client + MISC). */
export const TRANSACTION_DOCUMENT_DROPZONE_ACCEPT: Record<string, string[]> = {
    'application/pdf': ['.pdf'],
    'image/*': [],
    'application/msg': ['.msg'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-excel': ['.xls'],
};

export const TRANSACTION_DOCUMENT_FILE_TYPE_MESSAGE =
    'Only .pdf, Word, image, and Excel (.xlsx, .xls) files are allowed.';

const TRANSACTION_DOCUMENT_EXTENSIONS = new Set([
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'msg',
    'doc',
    'docx',
    'xls',
    'xlsx',
]);

export const isAllowedTransactionDocumentFileName = (fileName: string): boolean => {
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    return TRANSACTION_DOCUMENT_EXTENSIONS.has(extension);
};
